// Copyright (c) 2020 Deere & Company

import * as helpers from '../../../shared/components/facets/dealer-hierarchy/helpers';
import actions from '../../actions-list';

export const updateFilteredTerritories = (territories, text) =>
    dispatch => {

        const textToSearch = new RegExp(text, 'i');
        const filteredTerritories = helpers.filterTerritories(textToSearch, territories);
        const newSelections = helpers.generateSelectionMap(filteredTerritories);

        dispatch({
            territories: filteredTerritories,
            type: actions.UPDATE_TABM_FILTERED_TERRITORIES
        });

        const facets = {
            dealers: helpers.getListOfSelectedDealers(newSelections.selectedAccounts),
            ...newSelections
        };

        dispatch({
            facets,
            type: actions.UPDATE_TABM_WIP_FACETS
        });

    };



// WEBPACK FOOTER //
// ./src/tabm/wip/action-creators/filtered-territories.js